import { GetterTree } from 'vuex';
import { BlogState } from '@/store/blog/index';

export const blogGetters: GetterTree<BlogState, any> = {
  localizedArticles: (state: BlogState) => state.localizedArticles,
};
